// ========================================================
// FAST HIT Website — Firestore Collection Constants & Types
// Mirrors the admin panel contracts for consistency
// ========================================================

/** Firestore collection name constants */
export const COLLECTIONS = {
  USERS: 'users',
  TEAMS: 'teams',
  MATCHES: 'matches',
  TOURNAMENTS: 'tournaments',
  GROUNDS: 'grounds',
  UMPIRES: 'umpires',
  SCORERS: 'scorers',
  FEED: 'feed',
  REPORTS: 'reports',
  FOLLOWS: 'follows',
  NOTIFICATIONS: 'notifications',
  LOOKING_FOR: 'looking_for',
  LEADERBOARDS: 'leaderboards',
  CMS: 'cms',
  APP_SETTINGS: 'app_settings',
  FEATURE_FLAGS: 'feature_flags',
} as const;

/** Firestore subcollection name constants */
export const SUBCOLLECTIONS = {
  STATS: 'stats',
  ACHIEVEMENTS: 'achievements',
  MATCH_HISTORY: 'matchHistory',
  SETTINGS: 'settings',
  BLOCKS: 'blocks',
  MEDIA: 'media',
  PAYMENTS: 'payments',
  MEMBERS: 'members',
  SQUADS: 'squads',
  INNINGS: 'innings',
  SCORECARD: 'scorecard',
  TEAMS: 'teams',
  POINTS: 'points',
  FIXTURES: 'fixtures',
  LIKES: 'likes',
  COMMENTS: 'comments',
  FOLLOWING: 'following',
  FOLLOWERS: 'followers',
  ITEMS: 'items',
} as const;
